
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { NotificationService } from '../services/notification.service';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notificationService = inject(NotificationService);
  

  const modalErorr = (serviceError: { message: string; code: number }) => {
    notificationService.openModal({
      title: 'ERRORE',
      message: 'Ops... Non è stato possibile completare l\'operazione!',
      type: 'danger',
      choice: 'single',
      serviceError
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        modalErorr({
          message: error?.error?.message ?? 'Generic Error',
          code: error.status
        });
      }
      return throwError(() => error);
    })
  )
};
